import {
  ChangeEmailAddressPayload,
  ChangePasswordPayload,
  DeleteAccountPayload,
  I18nAccountError,
  Mutation as accountMutations,
} from './account/account-resolver-overrides';
import {
  UnsubscribeApacSavedSearchByCodePayload,
  ResubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,
  Mutation as notificationsMutations,
  Candidate as notificationCandidates,
} from './notifications/notifications-resolver-overrides';
import {
  UpdateShareableProfileSettingsPayload,
  Mutation as visibilityMutations,
} from './visibility/visibility-resolver-overrides';

const resolverOverrides = (_mockStore: any) => ({
  // Account:
  ChangeEmailAddressPayload,
  I18nAccountError,
  ChangePasswordPayload,
  DeleteAccountPayload,

  // Visibility:
  UpdateShareableProfileSettingsPayload,

  // Notifications:
  UnsubscribeApacSavedSearchByCodePayload,
  ResubscribeApacSavedSearchByCodePayload,
  UpdateNotificationCtpPreferencesPayload,
  UpdateNotificationCtpSubscriptionWithTokenPayload,

  Mutation: {
    ...accountMutations,
    ...visibilityMutations,
    ...notificationsMutations,
  },

  Candidate: {
    ...notificationCandidates,
  },
});

export default resolverOverrides;
